import { Core } from '@springtree/eva-services-core';
import { BehaviorSubject, map } from 'rxjs';
export class EvaContextEndpointStatus {
    /**
     * The role of an endpoint signifies its purpose with 'CLOUD' being the most used.
     * The WATCHTOWER and STORE endpoints will be important for (in-store) POS solutions
     */
    _role$ = new BehaviorSubject('CLOUD');
    get role$() { return this._role$.asObservable(); }
    get role() { return this._role$.getValue(); }
    /**
     * The current status indicates if the endpoint was recently reachable and can also indicate if it is slow to respond
     */
    _status$ = new BehaviorSubject('REACHABLE');
    get status$() { return this._status$.asObservable(); }
    get status() { return this._status$.getValue(); }
    /**
     * Helper attribute to get a boolean state for reachability
     */
    reachable$ = this._status$.pipe(map(status => status === 'REACHABLE' || status === 'SLOW'));
    get reachable() {
        return this.status === 'REACHABLE' || this.status === 'SLOW';
    }
    /**
     * Last recorded call latency in milliseconds
     */
    _latency$ = new BehaviorSubject(-1);
    get latency$() { return this._latency$.asObservable(); }
    get latency() { return this._latency$.getValue(); }
    _endpoint;
    _reachabilityCheckInterval;
    _reachabilityTimer;
    _slowThresholdMilliseconds;
    constructor({ endpoint, reachabilityCheckInterval, role, slowThresholdMilliseconds, status, }) {
        this._endpoint = endpoint;
        this._reachabilityCheckInterval = reachabilityCheckInterval ?? 7000;
        this._role$.next(role);
        this._slowThresholdMilliseconds = slowThresholdMilliseconds ?? 5000;
        this._status$.next(status);
    }
    async checkReachability() {
        try {
            const startTime = new Date().valueOf();
            await this._endpoint.callService(Core.ValidateToken);
            const endTime = new Date().valueOf();
            const latency = endTime - startTime;
            this._latency$.next(latency);
            if (latency > this._slowThresholdMilliseconds) {
                this._status$.next('SLOW');
            }
            else {
                this._status$.next('REACHABLE');
            }
        }
        catch (error) {
            this._status$.next('UNREACHABLE');
            this._latency$.next(-1);
        }
        this.start();
    }
    start() {
        if (this._reachabilityTimer === undefined && this._reachabilityCheckInterval > 0) {
            this._reachabilityTimer = setTimeout(() => this.checkReachability(), this._reachabilityCheckInterval);
        }
    }
    stop() {
        clearTimeout(this._reachabilityTimer);
        this._reachabilityTimer = undefined;
        this._status$.next('DISCONNECTED');
    }
}
//# sourceMappingURL=endpoint-status.js.map